var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturnsGlass = function SvgReturnsGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.6c-.3 0-.6-.2-.6-.5s.2-.6.5-.7l1.6-.2C32.6 21.3 38 14.4 38.2 6h-7.3l-1.8 4.4 1.8 1.8c.2.2.3.5.1.8l-4.2 6c-.2.3-.6.3-.8.1-.3-.2-.3-.6-.2-.8l4-5.5-1.7-1.7c-.2-.2-.2-.4-.1-.6l2-5.2c.1-.2.3-.4.6-.4h8.3c.3 0 .6.3.6.6 0 9.2-5.9 17-13.8 17.9l-1.7.2c.1 0 0 0 0 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43.1c-.3 0-.6-.2-.6-.6v-19l-1.1-.1c-7.9-1-13.8-8.7-13.8-17.9 0-.3.3-.6.6-.6h17.3c.3 0 .6.3.6.6s-.3.6-.6.6H9.7c.2 8.4 5.6 15.3 12.7 16.2l1.6.1c.3 0 .5.3.5.6v19.5c.1.4-.2.6-.5.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7 43.1H13.3c-.3 0-.6-.2-.6-.6 0-.3.3-.6.6-.6h21.4c.3 0 .6.3.6.6 0 .4-.3.6-.6.6z"
  })));
};
export default SvgReturnsGlass;